export default __webpack_public_path__ + "static/venti_cerrado-52fbe4e48b5d543565255ece7ae80a0b.png";